import { useEffect, useRef } from "react";
import { useWatch, useFormContext } from "react-hook-form";
import Input, { InputType } from "components/shared/inputs/input";
import useTranslation from "utils/hooks/useTranslation";
import { EtudeFormFields } from "../constants";
import { SystemCode } from "utils/engine/consts";

export const SimulationOptions: React.FC<{
  engineData: any;
  calculate2: () => void;
  calculationTriggered?: boolean;
  isVisible?: boolean;
}> = ({ engineData, calculate2, calculationTriggered, isVisible }) => {
  const { t } = useTranslation();

  const { watch, control } = useFormContext<EtudeFormFields>();

  const watchedFields = useWatch({
    control,
    name: [
      "nbBallon",
      "Jaquette",
      "Ouverture",
      "circPrim",
      "circSec",
      "brand",
      "circ",
    ],
  });

  const prevFields = useRef(watchedFields);

  useEffect(() => {
    if (!calculationTriggered) return;

    const prev = prevFields.current;
    const next = watchedFields;

    if (JSON.stringify(prev) !== JSON.stringify(next)) {
      calculate2();
    }

    prevFields.current = next;
  }, [watchedFields, calculationTriggered, calculate2]);
  const systeme = watch("systeme");

  if (!isVisible) return null;

  if (!engineData) {
    return <></>;
  }

  switch (systeme) {
    case SystemCode.ECHANGEUR_BALLONS_ECS:
      return (
        <group data-direction="row">
          <group data-direction="column" data-length="autofit">
            <text data-text-size="medium">{t("ballons_ecs")} :</text>
            <group data-direction="column" data-gap="10" data-length="400">
              <Input
                type={InputType.Select}
                name="nbBallon"
                control={control}
                options={engineData?.nbBallon?.enum}
                label={t("nombre")}
                translateValue
                emptyClass={false}
                onChangeCustom={calculate2}
              />
              <Input
                type={InputType.Select}
                name="Jaquette"
                control={control}
                options={engineData?.Jaquette?.enum}
                label={t("FO_ZONE4_JACKET")}
                translateValue
                emptyClass={false}
                onChangeCustom={calculate2}
              />
              <Input
                type={InputType.Select}
                name="Ouverture"
                control={control}
                options={engineData?.Ouverture?.enum}
                label={t("FO_ZONE4_OPENING")}
                translateValue
                emptyClass={false}
                onChangeCustom={calculate2}
              />
            </group>
          </group>
          <group data-direction="column" data-length="autofit">
            <text data-text-size="medium">{t("Echangeur")} :</text>
            <group data-direction="column" data-gap="10" data-length="400">
              <Input
                type={InputType.Select}
                name="circPrim"
                control={control}
                options={engineData?.circPrim?.enum}
                label={t("FO_ZONE4_PRIM_PUMP")}
                translateValue
                emptyClass={false}
                onChangeCustom={calculate2}
              />
              <Input
                type={InputType.Select}
                name="circSec"
                control={control}
                options={engineData?.circSec?.enum}
                label={t("FO_ZONE4_SEC_PUMP")}
                translateValue
                emptyClass={false}
                onChangeCustom={calculate2}
              />
            </group>
          </group>
        </group>
      );
    case SystemCode.BALLONS_ECS_PREPARATEURS:
      return (
        <group data-direction="column">
          <text data-text-size="medium">{t("Ballon(s) ECS")} :</text>
          <group data-direction="column" data-gap="10" data-length="400">
            <Input
              type={InputType.Select}
              name="Jaquette"
              control={control}
              options={engineData?.Jaquette?.enum}
              label={t("FO_ZONE4_JACKET")}
              translateValue
              emptyClass={false}
              onChangeCustom={calculate2}
            />
            <Input
              type={InputType.Select}
              name="Ouverture"
              control={control}
              options={engineData?.Ouverture?.enum}
              label={t("FO_ZONE4_OPENING")}
              translateValue
              emptyClass={false}
              onChangeCustom={calculate2}
            />
          </group>
        </group>
      );
    case SystemCode.ECHANGEUR_A_PLAQUES_BALLONS_PRIMAIRES:
      return (
        <group>
          <group data-direction="column">
            <text data-text-size="medium">{t("Ballon(s) primaire(s)")} :</text>
            <group data-direction="column" data-gap="10" data-length="400">
              <Input
                type={InputType.Select}
                name="nbBallon"
                control={control}
                options={engineData?.nbBallon?.enum}
                label="nbBallon"
                translateValue
                emptyClass={false}
              />
              <Input
                type={InputType.Select}
                name="Jaquette"
                control={control}
                options={engineData?.Jaquette?.enum}
                label="Jaquette"
                translateValue
                emptyClass={false}
              />
            </group>
          </group>
          <group data-direction="column">
            <text data-text-size="medium">{t("Echangeur")} :</text>
            <group data-direction="column" data-gap="10" data-length="400">
              <Input
                type={InputType.Select}
                name="circPrim"
                control={control}
                options={engineData?.circPrim?.enum}
                label="Circulateur primaire"
                translateValue
                emptyClass={false}
              />
            </group>
          </group>
          <group data-direction="column">
            <text data-text-size="medium">
              {t("Circulateur de charge du/des ballon(s)")} :
            </text>
            <group data-direction="column" data-gap="10" data-length="400">
              <Input
                type={InputType.Select}
                name="brand"
                control={control}
                options={engineData?.brand?.enum}
                label="Marque"
                translateValue
                emptyClass={false}
              />
              <Input
                type={InputType.Select}
                name="circ"
                control={control}
                options={engineData?.circ?.enum}
                label="Circulatur(s)"
                translateValue
                emptyClass={false}
              />
            </group>
          </group>
        </group>
      );
  }
};
